<template>
  <button
    ref="buttonRef"
    class="ui-dropdown-list-item ui-dropdown-actions-item"
    :class="mainClasses"
    :disabled="item.disabled"
    @click="handleClick"
  >
    <component
      :is="item.meta?.icon"
      v-if="!leadingIcon"
      class="ui-dropdown-list-item__icon ui-dropdown-actions-item__icon--trailing"
      aria-hidden="true"
    />
    <span>{{ item.label }}</span>
    <component
      :is="item.meta?.icon"
      v-if="leadingIcon"
      class="ui-dropdown-list-item__icon ui-dropdown-actions-item__icon--leading"
      aria-hidden="true"
    />
  </button>
</template>

<script setup lang="ts">
import { computed, useTemplateRef } from 'vue'

import { DropdownListData } from './utils/types'

type Props = {
  item: DropdownListData
  currentValue?: DropdownListData['value']
  selected?: boolean
  leadingIcon?: boolean
}

type Emits = {
  (e: 'click', value: string): void
}

const props = defineProps<Props>()
const emit = defineEmits<Emits>()

const isActive = computed(() => props.item.value === props.currentValue)

const mainClasses = computed(() => ({
  'ui-dropdown-list-item--active': isActive.value,
  'ui-dropdown-list-item--selected': props.selected,
  [`ui-dropdown-actions-item--${props.item.meta?.variant}`]:
    props.item.meta?.variant,
}))

const buttonRef = useTemplateRef<HTMLButtonElement>('buttonRef')

const handleClick = () => {
  buttonRef.value?.blur()
  emit('click', props.item.value)
}
</script>

<style>
.ui-dropdown-list-item {
  @apply flex items-center gap-2;
  @apply w-full;
  @apply disabled:opacity-50 disabled:cursor-not-allowed;

  &__icon {
    @apply size-4;

    &--leading {
      @apply -mr-1;
    }

    &--trailing {
      @apply -ml-1;
    }
  }
}

.ui-dropdown-actions-item {
  @apply text-sm sm:text-xs;

  &--primary {
    @apply text-indigo-500! dark:text-indigo-400!;
  }

  &--danger {
    @apply text-red-600! dark:text-red-400!;
  }
}
</style>
